/* Lire la carte en brut, ou en net.
 *
 * ── Pourquoi deux pastilles et non un interrupteur ──────────────────────────
 *
 * Un interrupteur dit « activé / désactivé » : il faudrait se souvenir de ce
 * que veut dire allumé. Deux mots posés côte à côte, celui qui s'applique en
 * clair sur le papier, disent l'état sans qu'on ait rien à retenir — c'est déjà
 * la forme des onglets des statistiques, et la main les trouve au même endroit.
 *
 * Le bouton DISPARAÎT quand le net n'est pas calculable : proposer un choix
 * sans effet est pire que ne rien proposer. Ce qui manque est dit à la place,
 * une fois, sous la carte.
 */
export function BasculeNet({ net, onChange }: {
    net: boolean;
    onChange: (v: boolean) => void;
}) {
    return (
        <div role="tablist" className="flex gap-1 rounded-field bg-base-200 p-0.5">
            {([[false, 'Brut'], [true, 'Net']] as const).map(([v, mot]) => (
                <button key={mot} role="tab" type="button"
                    aria-selected={net === v}
                    onClick={() => onChange(v)}
                    className={`rounded-field px-3 py-1.5 text-xs font-bold transition-colors ${
                        net === v ? 'bg-base-100 shadow-sm' : 'opacity-60 hover:opacity-100'
                    }`}>
                    {mot}
                </button>
            ))}
        </div>
    );
}
